import { render, staticRenderFns } from "./Vimeovideo.vue?vue&type=template&id=0f1b0042&scoped=true&"
import script from "./Vimeovideo.vue?vue&type=script&lang=js&"
export * from "./Vimeovideo.vue?vue&type=script&lang=js&"
import style0 from "./Vimeovideo.vue?vue&type=style&index=0&id=0f1b0042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b0042",
  null
  
)

export default component.exports